export default function Header(): JSX.Element {
  return (
    <div>
      <h1>Crochet Calculator</h1>
    </div>
  );
}
